export const BLANK_PLACEHOLDER = '--';
